import { useCallback } from 'react';
import { Button } from '../../components/Button';
import { Toast } from '../../components/Toast';
import { useAccount } from './account-context';

/** Account messages, such as a plan change, as a toast at the top of the page. */
export function AccountNotice() {
  const { notice, notify, openDialog } = useAccount();
  const dismiss = useCallback(() => {
    notify(null);
  }, [notify]);

  if (!notice) return null;
  const { action } = notice;
  return (
    <Toast
      key={notice.text}
      message={notice.text}
      tone={notice.tone}
      onDismiss={dismiss}
      action={
        action && (
          <Button
            className="bar-button"
            onClick={() => {
              notify(null);
              openDialog(action.dialog);
            }}
          >
            {action.label}
          </Button>
        )
      }
    />
  );
}
